import { Button, Checkbox, FormControlLabel, FormGroup, Grid, Typography } from '@material-ui/core';
import { Form, Formik } from 'formik';
import React from 'react';
import './style.css';
import { excluirPromocao } from '../../services/tabelaPrecoApi';
import { showMessageError, showMessageSuccess } from '../others/toastr';
import { BuscaCidadeCodigo } from '../../modulos/function/tabelaEdicaoPreco';

const BodyModalExclusaoDesconto = ({ rowData, setOpenModal, openModal, classes, setFieldValue, codigoCidade, setGetPromocao }) => {
    async function onSubmit(values) {
        const { pagamentoBoleto, pagamentoCartao, pagamentoEscelsa } = values;

        const formaPagamento =[];

        if(pagamentoBoleto){
            formaPagamento.push(1);
        }

        if(pagamentoCartao){
            formaPagamento.push(7);
        }

        if(pagamentoEscelsa){
            formaPagamento.push(8);
        }

        const dataExclusao = {
            formaPagamento,
            plano: rowData.subgrupo.trim(),
            idProduto: rowData.id
        };

        excluirPromocao(dataExclusao)
            .then(response => {
                if (response) {
                    showMessageSuccess('', 'Exclusão realizada com sucesso!');
                    BuscaCidadeCodigo(codigoCidade, setGetPromocao, 'Plano');
                    setOpenModal(false);
                } else if(response.status == 422){
                    showMessageError('OPS', 'Erro ao excluir promoção! Por favor, tente novamente.');
                } else if(response.status == 404){
                    showMessageError('OPS', 'Erro ao excluir promoção! Por favor, tente novamente.');
                }
            })
            .catch(err => {
                showMessageError('OPS', 'Erro ao excluir promoção! Por favor, tente novamente.');
            });
    }

    return <div className="ModalStyle PaperModalExclusao">
        <Typography variant="h6" gutterBottom>
            Exclusão desconto mensalidade
        </Typography>
        <div className="dentroModalExclusao">
            {openModal && (
                <>
                    <Formik onSubmit={onSubmit} initialValues={{ formasPagamento: '',
                        pagamentoCartao: false,
                        pagamentoBoleto: false,
                        pagamentoEscelsa: false }}>
                        {({ handleChange, onSubmit, values }) =>( 
                            <>
                                <Form>
                                    <Grid item xs={12} sm={6}>
                                        {rowData.descontoCartao || rowData.descontoBoleto || rowData.descontoEscelsa ? <FormGroup 
                                            row={true}>
                                            {rowData.descontoCartao &&
                                            <FormControlLabel 
                                                control={<Checkbox  color='primary' />} 
                                                label="Cartão " 
                                                id='pagamentoCartao'
                                                name='pagamentoCartao'
                                                onChange={handleChange}
                                            />}
                                            {rowData.descontoBoleto &&

                                            <FormControlLabel 
                                                control={<Checkbox color='primary'/>} 
                                                label="Boleto" 
                                                id='pagamentoBoleto'
                                                name='pagamentoBoleto'
                                                onChange={handleChange}

                                            />}
                                            {rowData.UF ==='ES' && rowData.descontoEscelsa && <> 
                                                <FormControlLabel 
                                                    control={<Checkbox color='primary'/>} 
                                                    label="Escelsa" 
                                                    id='pagamentoEscelsa'
                                                    name='pagamentoEscelsa'
                                                    onChange={handleChange}
                                                />
                                            </>}
                                        </FormGroup> :
                                            <span>
                                            Sem descontos cadastrados.
                                            </span>}
                                    </Grid>
                                    <Button
                                        className={classes.buttons}
                                        variant="contained"
                                        color="primary"
                                        type="submit"
                                        onClick={()=>onSubmit(values)}
                                    >
                                        {
                                            rowData.descontoCartao ||
                                            rowData.descontoBoleto ||
                                            rowData.descontoEscelsa ? 'Enviar' : 'Voltar'
                                        }
                                    </Button>
                                </Form>
                            </>)}
                    </Formik>
                </>
            )}
        </div>
    </div>;
};

export default BodyModalExclusaoDesconto;